export const formatTime = (isoString: string): string => {
  return new Date(isoString).toLocaleTimeString([], {
    hour: "numeric",
    minute: "2-digit",
  });
};

export const formatOz = (amount: number): string => {
  return amount.toFixed(1).replace(/\.?0+$/, "");
};

export const timeAgo = (isoString: string): string => {
  const seconds = Math.floor(
    (Date.now() - new Date(isoString).getTime()) / 1000,
  );
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);

  if (minutes < 1) return "Just now";
  if (minutes < 60) return `${minutes}m ago`;

  const remMinutes = minutes % 60;
  if (remMinutes === 0) return `${hours}h ago`;
  return `${hours}h ${remMinutes}m ago`;
};
